import styled from 'styled-components';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { StyledFlex } from '../../../../styles/common';
import { StyledText, StyledTitle } from '../../../../styles/text';
import { colors } from '../../../../styles/theme';
export const StyledCharts = styled(Inset) `
  background-color: ${colors.turquoiseLightest};
`;
export const StyledDetailsCharts = styled(StyledFlex) `
  flex-wrap: wrap;
  margin: 0;

  text {
    display: none;
  }
`;
export const StyledChart = styled.div `
  height: 200px;

  &:only-child {
    margin-right: auto;
  }
`;
export const StyledChartTitle = styled(StyledTitle) `
  font-size: 40px;
`;
export const StyledFooter = styled.div `
  width: 100%;
  transform: translateY(-68px);
`;
export const StyledFooterAxis = styled(StyledFlex) `
  /* this value adds required space between text and chart */
  transform: translateY(-4px);
`;
export const StyledAxisValue = styled(StyledText) `
  color: #4b7f9b;
  margin: 0;
  max-width: 286px;
  min-width: 40px;
`;
export const StyledLabel = styled(StyledText) `
  color: rgba(51, 51, 51, 0.87);
  width: 53%;
  margin: 0 auto 0 auto;
  transform: translateY(-25px);
`;
//# sourceMappingURL=subcomponents.js.map